// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"styles_breadcrumbs__0wwa6","breadcrumbs_link":"styles_breadcrumbs_link__YHqqu"};